import type { ReactNode } from 'react'
import { useNavigation } from 'react-router'

interface PageShellProps {
  children: ReactNode
}

export function PageShell({ children }: PageShellProps) {
  const navigation = useNavigation()
  const isNavigating = navigation.state === 'loading'

  return (
    <main className="wefa-page-shell">
      <div className={`wefa-page-shell__body${isNavigating ? ' is-navigating' : ''}`}>
        {children}
      </div>
    </main>
  )
}
